import { ReactNode } from 'react';
import { cn } from './lib';
import './Badge.css';

type BadgeProps = {
  variant?: 'neutral' | 'brand' | 'success' | 'warn' | 'danger' | 'demo';
  children: ReactNode;
  className?: string;
  /* Declared rather than inherited from the span: a hyphenated JSX
     attribute is exempt from excess-property checking, so a caller passing
     `data-testid` to a component that did not accept one compiled happily
     and rendered nothing. A badge is often the one thing on a record that
     says what state it is in, so naming it here is what makes that state
     reachable from a test — `record-status` resolved nowhere until it was. */
  'data-testid'?: string;
  /* And the words behind a badge whose label had to be shortened to fit. */
  title?: string;
};

export function Badge({ variant = 'neutral', children, className, 'data-testid': testId, title }: BadgeProps) {
  return (
    <span className={cn('mrd-badge', `mrd-badge--${variant}`, className)} data-testid={testId} title={title}>
      {children}
    </span>
  );
}
